export default {
    'payment-failure': {
        'caption': 'Sorry, your payment did not go through.',
        'text': `No money has been deducted from your account.
        <br/>Please try again using the form provided.
        <br/>If you continue to encounter problems please contact us directly.`,
        'main': 'Main page',
        'contact': 'Contact',
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/site/paymentFailure/i18n/en.js